import { Component, OnInit } from '@angular/core';
import { Platform, ToastController } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

import { NavigationBar } from '@squareetlabs/capacitor-navigation-bar';


import { register } from 'swiper/element/bundle';
import { MysqlService } from './services/mysql.service';
import { App } from '@capacitor/app';
import { UpdateService } from './services/update.service';
import { FabService } from './services/fa.service';

register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styles: [`
    
        
    @media (orientation: landscape) {
      .orientation-popup {
        visibility: hidden;
      }
    }

`]
})

export class AppComponent implements OnInit {

  //isCameraMode = false;
  networkStatus: 'ok' | 'slow' | 'offline' = 'ok';

  showNetworkMsg: boolean = false;
  hideTimer: any;

  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Nuovo incarico test',
      url: '/test',
      icon: 'logo-android'
    },
  /*  {
      title: 'Solera',
      url: '/solera',
      icon: 'home'
    },*/ {
      title: 'Storage',
      url: '/storage',
      icon: 'home'
    }, {
      title: 'Uploader',
      url: '/uploader',
      icon: 'home'
    },
    {
      title: 'Logout',
      url: '/login/out',
      icon: 'exit'
    }
  ];

  constructor(
    private platform: Platform,
    public db: MysqlService,
    public updateService: UpdateService,
    public fab: FabService

  ) {
    //alert('init')
    this.initializeApp();
    this.updateService.checkVersion();
  }

  ngOnInit() {
    this.checkNetworkSpeed();
  }



  async showSplash() {

    // Hide the splash (you should do this on app launch)
    await SplashScreen.hide();


    // Show the splash for two seconds and then automatically hide it:
    /*
    await SplashScreen.show({
      showDuration: 2000,
      autoHide: true,
    });
    */
  }

  color;

  lastOrientation
  initializeApp() {
    this.platform.ready().then(async () => {

      this.fullscreen();
      this.updateService.checkUpdateCapgo();

      App.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
          // Quando l'app torna attiva, forza di nuovo l'occultamento
          this.fullscreen();
        }
      });



      navigator.serviceWorker.ready.then((registration) => {
        console.log('Service Worker is ready:', registration);
      });

    });
  }


  async fullscreen() {
    try {
      document.documentElement.requestFullscreen();
    } catch (error) {

    }


    if (this.platform.is('capacitor') && this.platform.is('android')) {



      // Nasconde la barra di stato e permette al layout di espandersi

      try {
        await StatusBar.hide();
      } catch (error) {
        alert('Error hiding status bar: ' + error);
      }

      try {
        await NavigationBar.hide();
      } catch (error) {
        alert('Error hiding navigation bar: ' + error);
      }

      //await NavigationBar.setState({ state: 'immersive' });
    }


    /*
    try {
      AndroidFullScreen.isImmersiveModeSupported()
        .then(() => AndroidFullScreen.immersiveMode())
        .catch(console.warn);
    } catch (error) {

    }*/
  }


  async checkNetworkSpeed() {

    if (!navigator.onLine) {
      this.setNetworkMsg('offline');
      return;
    }

    try {
      const start = performance.now();

      await this.db.app_speedtest();

      const ms = performance.now() - start;

      if (ms > 1000) {
        this.setNetworkMsg('slow');
      }
      else {
        this.networkStatus = 'ok';
        this.showNetworkMsg = false;
      }

    } catch (e) {
      this.setNetworkMsg('offline');
    }
  }

  setNetworkMsg(status: 'slow' | 'offline') {
    this.networkStatus = status;
    this.showNetworkMsg = true;

    clearTimeout(this.hideTimer);

    this.hideTimer = setTimeout(() => {
      this.showNetworkMsg = false;
    }, 10000);
  }


}

